import React from 'react';
import {UserContext} from './Context/UserContext';

const InstanceContext = React.createContext();

const reducer = (state, action) => {
  switch(action.type) {
    case 'updateInstance':
      sessionStorage.setItem('lastInstance', action.instance)
      return {
        ...state,
        instance: action.instance
      }
    default: return {instance: action.instance};
  }
};

const InstanceContextProvider = props => {
  const {userAction, user} = React.useContext(UserContext);
  const [state, dispatch] = React.useReducer(reducer, {instance: false});
  if (state.instance && user.instance !== state.instance && !user.isXDAdmin) {
    user.isXDAdmin
    ? userAction({
      type: 'updateUser',
      property: 'instance',
      value: state.instance
    })
    : userAction({type: 'logout'});
  }
  return(
    <InstanceContext.Provider
      value={{
        contextInstance: state.instance,
        updateContextInstance: dispatch
      }}
    >
      {props.children}
    </InstanceContext.Provider>
  )
}

const InstanceContextConsumer = InstanceContext.Consumer;

export {InstanceContext, InstanceContextProvider, InstanceContextConsumer};
